import axios from '../axios'
export const getBaseEquipmentPage = (data) => {
  return axios({
    url: '/api/sys/base/equipment/getBaseEquipmentPage',
    method: 'post',
    data
  })
}
//设备管理列表 新增
export const saveBaseEquipment = (data) => {
  return axios({
    url: '/api/sys/base/equipment/saveBaseEquipment',
    method: 'post',
    data
  })
}

//设备管理列表 修改
export const updateBaseEquipment = (data) => {
  return axios({
    url: '/api/sys/base/equipment/updateBaseEquipment',
    method: 'post',
    data
  })
}

//设备管理列表 删除
export const deleteBaseEquipments = (data) => {
  return axios({
    url: '/api/sys/base/equipment/deleteBaseEquipments',
    method: 'post',
    data
  })
}
//设备管理列表 状态
export const statusBaseEquipments = (data) => {
  return axios({
    url: '/api/sys/base/equipment/statusBaseEquipments',
    method: 'post',
    data
  })
}
//设备人员管理列表
export const getIotDeviceEmployeePage = (data) => {
  return axios({
    url: '/api/sys/iot/getIotDeviceEmployeePage',
    method: 'post',
    data
  })
}
//设备人员管理 新增
export const batchSaveIotDeviceEmployee = (data) => {
  return axios({
    url: '/api/sys/iot/batchSaveIotDeviceEmployee',
    method: 'post',
    data
  })
}
//设备人员管理 修改
export const updateIotDeviceEmployee = (data) => {
  return axios({
    url: '/api/sys/iot/updateIotDeviceEmployee',
    method: 'post',
    data
  })
}
//设备人员管理 删除
export const deleteIotDeviceEmployees = (data) => {
  return axios({
    url: '/api/sys/iot/deleteIotDeviceEmployees',
    method: 'post',
    data
  })
}
//启用设备在线检测
export const checkIotDevice = (data) => {
  return axios({
    url: '/api/sys/iot/device/checkIotDevice',
    method: 'post',
    data
  })
}
//开门
export const openDoor = (data) => {
  return axios({
    url: '/api/sys/iot/device/openDoor',
    method: 'post',
    data
  })
}
//访客预约-列表
export const getMeterVisitorBookingPage = (data) => {
  return axios({
    url: '/api/sys/meter/getMeterVisitorBookingPage',
    method: 'post',
    data
  })
}
//访客预约-查询随行人员
export const getMeterVisitorBookingPersonPage = (data) => {
  return axios({
    url: '/api/sys/meter/getMeterVisitorBookingPersonPage',
    method: 'post',
    data
  })
}
//访客预约-保存
export const saveMeterVisitorBooking = (data) => {
  return axios({
    url: '/api/sys/meter/saveMeterVisitorBooking',
    method: 'post',
    data
  })
}
//访客预约-修改
export const updateMeterVisitorBooking = (data) => {
  return axios({
    url: '/api/sys/meter/updateMeterVisitorBooking',
    method: 'post',
    data
  })
}
//访客预约-取消
export const cancelMeterVisitorBookings = (data) => {
  return axios({
    url: '/api/sys/meter/cancelMeterVisitorBookings',
    method: 'post',
    data
  })
}
//访客预约-审核
export const auditMeterVisitorBookings = (data) => {
  return axios({
    url: '/api/sys/meter/auditMeterVisitorBookings',
    method: 'post',
    data
  })
}
//访客预约-进厂
export const arriveMeterVisitorBooking = (data) => {
  return axios({
    url: '/api/sys/meter/arriveMeterVisitorBooking',
    method: 'post',
    data
  })
}
//访客预约-离厂
export const leaveMeterVisitorBooking = (data) => {
  return axios({
    url: '/api/sys/meter/leaveMeterVisitorBooking',
    method: 'post',
    data
  })
}
//访客预约-查询进出记录
export const getMeterVisitorBookingPassPage = (data) => {
  return axios({
    url: '/api/sys/meter/getMeterVisitorBookingPassPage',
    method: 'post',
    data
  })
}
//访客预约-导出
export const exportMeterVisitorBookingList = (data) => {
  return axios({
    url: '/api/sys/meter/exportMeterVisitorBookingList',
    method: 'post',
    data
  })
}
//访客进出记录
export const getMeterVisitorBookingPassDetail = (data) => {
  return axios({
    url: '/api/sys/meter/getMeterVisitorBookingPassDetail',
    method: 'post',
    data
  })
}
//访客进出记录-导出
export const exportMeterVisitorBookingPassDetail = (data) => {
  return axios({
    url: '/api/sys/meter/exportMeterVisitorBookingPassDetail',
    method: 'post',
    data
  })
}
//工厂区域管理列表
export const getMeterFactoryAreaPage = (data) => {
  return axios({
    url: '/api/sys/meter/factory/area/getMeterFactoryAreaPage',
    method: 'post',
    data
  })
}
//设备落杆
export const closeDoor = (data) => {
  return axios({
    url: '/api/sys/iot/device/closeDoor',
    method: 'post',
    data
  })
}
//设备在线检测类型
export const deviceCheckTypeList = (data) => {
  return axios({
    url: '/api/sys/iot/device/deviceCheckTypeList',
    method: 'post',
    data
  })
}
//设备在线检测抓拍
export const snapshotIotDevice = (data) => {
  return axios({
    url: '/api/sys/iot/device/snapshotIotDevice',
    method: 'post',
    data
  })
}
//设备在线一键抓拍
export const capture = (data) => {
  return axios({
    url: '/api/sys/iot/device/iotDeviceDigestAuthHeader',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/equipment.js